module.exports = __webpack_public_path__ + "fonts/Inter-800-greek-ext73.2d64d8a.woff2";